import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import CatListingFilter from "./CatListing-filter";
import axios from "axios";
import BASE_URL from "../../../baseUrl";
import ListingFilter from "../pricing/ListingFilter";
import ListingCard from "../../shared/ListingCard";

const Content = ({ listingtype, searchedData }) => {
  const [state, setState] = useState([]);
  const [NotFound, setNotFound] = useState(false);
  const [SearhingData, setSearhingData] = useState();
  const [Data, setdata] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  const { t } = useTranslation();
  const { type } = useParams();
  const allType =
    listingtype === "Buy" || listingtype === "Sell"
      ? "Sell"
      : listingtype === "Rent"
        ? "Rent"
        : "all";
  const getData = async () => {
    try {
      if (searchedData?.msg === "location data") {
        setState(searchedData?.data);
      } else {
        const response = await fetch(
          `${BASE_URL}/submitlisting/submitListingType/${type}/${allType}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              mode: "no-cors",
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data from the server");
        }
        const data = await response.json();

        if (data.result?.length === 0) {
          setNotFound(true);
        } else {
          setNotFound(false);
        }
        setState(data.result);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getData();
  }, [listingtype, searchedData?.msg, type]);

  useEffect(() => {
    if (SearhingData) {
      setdata(SearhingData);
    }
  }, [SearhingData]);

  const getSearchData = async () => {
    try {
      if (searchedData?.msg === "location data") {
        setState(searchedData?.data);
      } else {
        const response = await axios.post(`${BASE_URL}/submitlisting/search`, {
          city: Data.city,
          type: Data.Propertytype ? Data.Propertytype : "Any Property",
          priceRange: Data.Pricerange,
          country: Data.country,
        });
        if (response) {
          setState(response.data.result);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const acessChat = () => {
    return;
  };

  const filterData = (data) => { };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = state.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(state.length / itemsPerPage);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div className="container flex justify-center">
        <div className="shadow-sm mt-3 rounded">
          <ListingFilter getData={filterData} />
        </div>
      </div>
      <div className="flex justify-center">
        <div className="my-8 container">
          {NotFound ? (
            <div className="flex justify-center">
              <div className="md:w-9/12 lg:w-4/6 my-4 border p-10 border-gray-500 rounded-lg flex justify-between items-center">
                <div className="w-32 pr-12">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/exclaimationMark.png`}
                    alt="ExclaimationMark"
                    width={"100%"}
                  />
                </div>
                <div className="w-10/12">
                  <h2 className="mb-4 text-gray italic">
                    {t(`${type} Property Not Found`)}
                  </h2>
                  <p className="text-gray-200">{t(`Sorry, the `)}</p>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="row">
                {currentItems.length > 0 ? (
                  currentItems.map((res, key) => (
                    <div key={key} className="col-lg-4 col-md-6 mb-4">
                      <ListingCard listing={res} t={t} />
                    </div>
                  ))
                ) : (
                  <div className="flex justify-center mt-5">
                    <h5>{t("No results found")}</h5>
                  </div>
                )}
              </div>
              <div className="d-flex justify-content-center mt-4">
                <nav aria-label="...">
                  <ul className="pagination">
                    <li
                      className={`page-item ${currentPage === 1 ? "disabled" : ""
                        }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(currentPage - 1)}
                      >
                        Previous
                      </button>
                    </li>
                    {[...Array(totalPages)].map((_, index) => (
                      <li
                        key={index}
                        className={`page-item ${currentPage === index + 1 ? "active" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    ))}
                    <li
                      className={`page-item ${currentPage === totalPages ? "disabled" : ""
                        }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(currentPage + 1)}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Content;
